import { getField, updateField } from "vuex-map-fields";
import { droneService } from "../services";
import { EventBus } from "@/helpers";

export const drone = {
  namespaced: true,
  state: {
    droneOptions: [],
    dronesList: [],
    areas: []
  },
  actions: {
    getDroneOptions(context) {
      return droneService
        .getDroneOptions()
        .then(response => {
          console.log(response);
          context.commit("setDroneOptions", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneOptions: ", error);
          EventBus.$emit("failedGetDroneOptions", error);
        });
    },
    getDroneList(context) {
      return droneService
        .getDroneList()
        .then(response => {
          console.log(response);
          context.commit("setDroneList", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneList: ", error);
          EventBus.$emit("failedGetDroneList", error);
        });
    },
    addDrone(context, payload) {
      return droneService
        .addDrone(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getDroneList");
        })
        .catch(error => {
          console.log("Error addDrone: ", error);
          EventBus.$emit("failedAddDrone", error);
        });
    },
    updateDrone(context, payload) {
      return droneService
        .updateDrone(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getDroneList");
        })
        .catch(error => {
          console.log("Error updateDrone: ", error);
          EventBus.$emit("failedUpdateDrone", error);
        });
    },
    deleteDrone(context, payload) {
      return droneService
        .deleteDrone(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getDroneList");
        })
        .catch(error => {
          console.log("Error deleteDrone: ", error);
          EventBus.$emit("failedDeleteDrone", error);
        });
    },
    getAreas(context, payload) {
      return droneService
        .getAreas(payload)
        .then(response => {
          console.log(response);
          context.commit("setAreas", {
            response
          });
        })
        .catch(error => {
          console.log("Error getAreas: ", error);
          EventBus.$emit("failedGetAreas", error);
        });
    },
    createArea(context, payload) {
      return droneService
        .createArea(payload)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error createArea: ", error);
          EventBus.$emit("failedCreateArea", error);
        });
    },
    updateArea(context, payload) {
      return droneService
        .updateArea(payload)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error updateArea: ", error);
          EventBus.$emit("failedUpdateArea", error);
        });
    },
    deleteArea(context, payload) {
      return droneService
        .deleteArea(payload)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log("Error deleteArea: ", error);
          EventBus.$emit("failedDeleteArea", error);
        });
    }
  },
  mutations: {
    updateField,
    setDroneOptions(state, payload) {
      console.log("setDroneOptions payload = ", payload);
      if (payload) {
        var locale = window.localStorage.getItem("locale");
        var not_in_list =
          locale === "fr"
            ? "-- N'EST PAS SUR LA LISTE --"
            : " -- NOT IN LIST --";
        state.droneOptions = JSON.parse(payload.response.data);
        state.droneOptions.unshift({
          manufacturer: not_in_list,
          models: []
        });
        state.droneOptions.forEach(manufacturer => {
          manufacturer.models.unshift({ name: not_in_list });
        });
      } else {
        state.droneOptions = [];
      }
    },
    setDroneList(state, payload) {
      console.log("setDroneList payload = ", payload);

      state.dronesList = JSON.parse(payload.response.data);
      var drone = {
        ID: "",
        Brand: "",
        BrandShort: "",
        DroneName: "",
        TCCredit: "",
        TakeoffWeight: "",
        MaxServiceCeilingAboveSeaLevel: "",
        OperatingTemperatureRangeLow: "",
        OperatingTemperatureRangeHigh: "",
        Controlledairspace: "",
        Nearpeople: "",
        Overpeople: "",
        TakeoffWeighting: "",
        MaxDistance: "",
        MaxAscentSpeed: "",
        MaxDescentSpeed: "",
        MaxSpeed: "",
        MaxWindResistance: "",
        Battery: "",
        MaxFlightTime: "",
        RemoteBattery: "",
        MaxTransmissionDistance: ""
      };
      state.dronesList.push(drone);
    },
    setAreas(state, payload) {
      console.log("setAreas payload = ", payload);
      if (payload) {
        state.areas = JSON.parse(payload.response.data);
      } else {
        state.areas = [];
      }
      EventBus.$emit("gotAreas");
    }
  },
  getters: {
    getField
  }
};
